import { MessageSquare } from "lucide-react";
import Layout from "../components/Layout";
import { EmptyState } from "../components/ui/empty-state";

export default function Werkgeversinzichten() {
  return (
    <Layout title="Werkgeversinzichten" subtitle="Signalen en berichten uit de markt">
      <EmptyState
        icon={<MessageSquare />}
        title="Werkgeversinzichten komt binnenkort"
        description="Hier verschijnen straks signalen en berichten uit de markt."
        className="mx-auto max-w-[1000px] rounded-card border border-waves-line py-20"
      />
    </Layout>
  );
}
